import { filterFramesByLocation } from '../../utilities/filters';
import { parseUrlSearchParams } from '../../config';

function inputReInitialization(element) {
  element.value = '';
  const clone = element.cloneNode(true);
  element.parentNode.appendChild(clone);
  element.remove();
  clone.addEventListener('change', (e) => {
    sendAutofillMessage(e.target, e.target.value);
  });
}

export function sendAutofillMessage(target, value) {
  const frames = filterFramesByLocation(window.parent.frames, window.location.origin);
  for (let f = 0; f < frames.length; f++) {
    const frame = frames[f];
    const configuration = parseUrlSearchParams(frame.location.hash);
    if (configuration.autoComplete === target.getAttribute('autocomplete')) {
      frame.postMessage({ autofill: true, value: value }, '*');
    }
  }
  inputReInitialization(target);
}

export function correctExpirationDateAutofill(value) {
  const month = value.split('/')[0];
  const year = value.split('/')[1].slice(-2);
  return `${month}${year}`;
}
